"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureHoneycombResource = void 0;
const resources_1 = require("@opentelemetry/resources");
const version_1 = require("./version");
function configureHoneycombResource() {
    return new resources_1.Resource({
        'honeycomb.distro.version': version_1.VERSION,
        'honeycomb.distro.runtime_version': 'browser',
    });
}
exports.configureHoneycombResource = configureHoneycombResource;
